'use client'

import React from 'react'
import ProductMobile from './_components/product.mobile'
import { useProductCartRedirect } from '@/app/[locale]/_hooks/useProductCartRedirect'
import { IProduct } from '../../_types'
import '@smastrom/react-rating/styles.css'

export default function ProductResponsive({
  data,
  slug,
  onSuccess,
  onRedirectToCart: onRedirectToCartProp,
}: {
  data?: IProduct
  slug?: string
  onSuccess?: () => void
  onRedirectToCart?: () => void
}) {
  const defaultRedirectToCart = useProductCartRedirect(onSuccess)
  const onRedirectToCart = onRedirectToCartProp ?? defaultRedirectToCart

  return (
    <ProductMobile
      data={data}
      slug={slug}
      onSuccess={onSuccess}
      onRedirectToCart={onRedirectToCart}
    />
  )
}
